<template>
  <MarketInsightsPage
    v-slot="{ slug, categoriesArticles, playVideo }"
    :market="RARE_EARTHS"
  >
    <NuxtPage
      :slug="slug"
      :categories-articles="categoriesArticles"
      :categories-videos="categoriesArticles"
      @play-video="playVideo"
    />
  </MarketInsightsPage>
</template>

<script setup lang="ts">
import MarketInsightsPage from '~/components/market/MarketInsightsPage.vue'
import { RARE_EARTHS, MARKET } from '~/constants/services/constants'

const { getSeoInfo } = useSeo()

const seo = getSeoInfo({
  title: `${MARKET.name}: ${RARE_EARTHS.name} Market Insights`,
})
useHead(seo)

definePageMeta({ layout: 'services' })
</script>
